// src/callapi/apiConfig.js

const API_HOST = import.meta.env.DEV
    ? ''
    : import.meta.env.VITE_API_HOST || 'https://api.pay2s.vn';
export const API_BASE_URL = `${API_HOST}/api/v1`;
